{
	"addMenu": "Agregar un nuevo menú",
	"create": "Crear menú",
	"day": "Día",
	"editMenu": "Editar menú",
	"end": "Cierre",
	"endTime": "Hora de cierre",
	"menuForm": {
		"delivery": "Delivery",
		"table": "Comanda en mesa"
	},
	"menuInformation": "Información del menú",
	"name": "Nombre del menú",
	"save": "Guardar cambios",
	"start": "Apertura",
	"startTime": "Hora de apertura",
	"type": "Tipo de menú",
	"validateField": "Campo obligatorio",
	"workingPeriods": "Horario del menú"
}
